import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { AppStateType } from '../../../bll/store'
import errorHandler from '../../../bll/errorHandler'
import openNotification from '../../_ui/notification'
import Portfolio from './portfolio'
import { Loader } from 'rsuite'
import { clearGroups, getGroups } from '../../../bll/portfolio/portfolioOperations'


const PortfolioContainer = (props: any) => {
    const navigate = useNavigate()

    const [getFilterGroupName, setFilterGroupName] = React.useState('') // Фильтр по имени группы
    const [getFilterGroupYear, setFilterGroupYear] = React.useState('') // Фильтр по году группы

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader

    React.useEffect(() => {
        if (!props.disabledTab) {
            setIsVisibleLoader(true)

            props.getGroups().then((result: any) => {
                setIsVisibleLoader(false)
                
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Список групп...", props.msg.err_0037, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        } else {
            openNotification("Доступ запрещен...", props.msg.warn_0003, "warning", "bottomRight")
            navigate('/main')
        }

        return () => {
            props.clearGroups()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Свойства передаваемые в компоненту
    const propsToPortfolio = {
        getFilterGroupName, setFilterGroupName, // Фильтр по имени группы
        getFilterGroupYear, setFilterGroupYear, // Фильтр по году группы
    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Portfolio {...props} {...propsToPortfolio} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        groupsList: state.portfolio.groupsList
    }
}

export default compose(connect(mapState, { getGroups, clearGroups }))(PortfolioContainer)